/*
 * Module for the _DropTransactionList partial view
 */
rs.module("ui/content/account/overview/droptransactionlist",

    [],

    function () {

        function initialize(listApi, backendUrls, dropAccountKey) {

            listApi.onItemClick(function (e, context) {

                listApi.detail.updateTitle("Transaction Details");

                $.get(
                    backendUrls.getDropTransactionDetail,
                    {
                        dropAccountKey: dropAccountKey,
                        dropTransactionKey: context.DropTransactionKey
                    }
                ).done(function (html) {
                    listApi.detail.loadDetail(html);
                }).fail(function () {
                    listApi.detail.clearDetail();
                });
            });
        }

        var exports = {
            initialize: initialize
        };

        return exports;
    }
);
